<template>
  <Pagination class="ts-pagination" layout="prev, pager, next" v-bind="$attrs" v-on="$listeners"></Pagination>
</template>

<style lang="scss" scoped>
.ts-pagination::v-deep {
  button,
  .el-pager li {
    background-color: transparent;

    font-family: Roboto;
    font-size: 12px;
    color: #9aa5b7;

    &.active,
    &:hover {
      color: #39c88c;
    }
  }
}
</style>

<script>
import { Pagination } from 'element-ui';

export default {
  name: 'TsPagination',
  components: {
    Pagination
  }
};
</script>
